module.exports = __webpack_public_path__ + "static/img/name.ccff3076.svg";